import React from 'react';

import WpSelectV2 from '../WpSelectV2';

import { WpForm, WpFormLayout } from '../../form';
import { WpButton } from '../../button';

const Select = () => {
  const WithSimpleArray = () => {
    return (
      <>
        <h5>With Simple Array</h5>
        <WpFormLayout direction="horizontal">
          <WpSelectV2
            id="select_basic_array"
            label="select example"
            placeholder="select your salutation"
            options={['Mr.', 'Mrs.', 'Dr.']}
          />
        </WpFormLayout>
      </>
    );
  };

  const WithBasicObjectArray = () => {
    return (
      <>
        <h5>With Basic Object Array</h5>
        <WpFormLayout direction="horizontal">
          <WpSelectV2
            id="select_basic_object"
            label="select example"
            placeholder="select your salutation"
            value="mr"
            options={[
              { value: 'mr', label: 'Mr.' },
              { value: 'mrs', label: 'Mrs.' },
            ]}
          />
        </WpFormLayout>
      </>
    );
  };

  const WithFrom = () => {
    const handleSubmit = values => {
      console.log('-- submitted data: ', values);
      alert('Submitted! check console log for data');
    };

    return (
      <>
        <h5>With Form</h5>
        <WpForm onSubmit={handleSubmit}>
          <WpFormLayout>
            <WpSelectV2
              id="select_form_input"
              label="select example"
              placeholder="select your salutation"
              required
              options={[
                { value: 'mr', label: 'Mr.' },
                { value: 'mrs', label: 'Mrs.' },
              ]}
            />
            <WpButton btnType="submit">submit</WpButton>
          </WpFormLayout>
        </WpForm>
      </>
    );
  };

  const WithCustomOptionComponent = () => {
    const DropdownOption = ({ option }) => {
      return (
        <div style={{ marginTop: '4px', marginBottom: '4px' }}>
          <p style={{ fontSize: '14px', color: 'black', margin: '0px' }}>{option.label}</p>
          <p style={{ fontSize: '12px', color: 'grey', margin: '0px' }}>Weekly on Wednesday</p>
        </div>
      );
    };

    return (
      <>
        <h5>With Custom Option Component </h5>
        <WpFormLayout>
          <WpSelectV2
            id="next_meeting"
            label="Select your next 1:1"
            placeholder="search your  meetings"
            prefixIcon="calendar-alt"
            value="George Cooper"
            options={[
              {
                value: 'George Cooper',
                label: 'Alex/George weekly 1:1',
                type: 'admin',
                isActive: true,
                avatar: {
                  color: '#F5C20D',
                  initials: 'J9',
                  profilePictureUrl:
                    'http://localhost:5000/rails/active_storage/representations/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBazAzIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--97d1bb9b819246fd210f22193eea43a422b4f996/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdCam9VWTI5dFltbHVaVjl2Y0hScGIyNXpldzA2QzNKbGMybDZaVWtpRFRJMU5uZ3lOVFplQmpvR1JWUTZER2R5WVhacGRIbEpJZ3RqWlc1MFpYSUdPd2RVT2d0bGVIUmxiblJKSWd3eU5UWjRNalUyQmpzSFZEb0tjM1J5YVhCVU9oUnpZVzF3YkdsdVp5MW1ZV04wYjNKSklnbzBPakk2TUFZN0IxUTZESEYxWVd4cGRIbEpJZ2M0TlFZN0IxUTZEbWx1ZEdWeWJHRmpaVWtpQ1VwUVJVY0dPd2RVT2c5amIyeHZjbk53WVdObFNTSUpjMUpIUWdZN0IxUT0iLCJleHAiOm51bGwsInB1ciI6InZhcmlhdGlvbiJ9fQ==--9b7e7e705270d9e568ade03820f3b541acbe5ba9/mike.jpg',
                  label: 'joshs 9',
                },
              },
              {
                value: 'Ginny Wesley',
                label: 'Alex/Ginny Weekly 1:1',
                disabled: true,
                type: 'amin',
                isActive: false,
                avatar: { color: '#5C6ECB', initials: 'DM', profilePictureUrl: null, label: 'dj matthew' },
              },
              {
                value: 'Geraldine',
                label: 'Geraldine Weekly 1:1',
                type: 'user',
                isActive: true,
                avatar: {
                  color: '#D41C8A',
                  initials: 'MT',
                  profilePictureUrl: null,
                  label: 'Michael T.',
                },
              },
              {
                value: 'Mark Johonson',
                label: 'Touchpoint with mark',
                type: 'user',
                isActive: true,
                avatar: {
                  color: '#D41C8A',
                  initials: 'MT',
                  profilePictureUrl: null,
                  label: 'Michael T.',
                },
              },
              {
                value: 'Albert Wong',
                label: 'Albert <> Alex',
                type: 'user',
                isActive: true,
                avatar: {
                  color: '#D41C8A',
                  initials: 'MT',
                  profilePictureUrl: null,
                  label: 'Michael T.',
                },
              },
              {
                value: 'Robert McTavish',
                label: 'sync with robert 1',
                type: 'user',
                isActive: true,
                avatar: {
                  color: '#D41C8A',
                  initials: 'MT',
                  profilePictureUrl: null,
                  label: 'Michael T.',
                },
              },
              {
                value: 'Joseph Garfunkle',
                label: 'Alex <> Joseph',
                type: 'user',
                isActive: true,
                avatar: {
                  color: '#D41C8A',
                  initials: 'MT',
                  profilePictureUrl: null,
                  label: 'Michael T.',
                },
              },
              {
                value: 'Mo Lincoln',
                label: 'Weekly Sync',
                type: 'user',
                isActive: true,
                avatar: {
                  color: '#D41C8A',
                  initials: 'MT',
                  profilePictureUrl: null,
                  label: 'Michael T.',
                },
              },
              {
                value: 'bobby madison',
                label: '1:1 with Bobby',
                type: 'user',
                isActive: true,
                avatar: {
                  color: '#D41C8A',
                  initials: 'MT',
                  profilePictureUrl: null,
                  label: 'Michael T.',
                },
              },
            ]}
            components={{ option: DropdownOption }}
            isSearchable
          />
          <WpButton variant="tertiary">or create manually</WpButton>
        </WpFormLayout>
      </>
    );
  };

  return (
    <>
      <WithSimpleArray />
      <hr />
      <WithBasicObjectArray />
      <hr />
      <WithFrom />
      <hr />
      <WithCustomOptionComponent />
    </>
  );
};

export default Select;
